const key = 'admin-logged-in'

export function loggedIn() {
  return localStorage.getItem(key) === '1'
}

export function setLoggedIn() {
  return localStorage.setItem(key, '1')
}

export function removeLoggedIn() {
  return localStorage.removeItem(key)
}

export function setToken(key,value) {
  return localStorage.setItem(key,value)
}

export function getToken(key) {
  return localStorage.getItem(key)
}
export function removeToken(key) {
  return localStorage.removeItem(key)
}
